import { CenterCostData } from '../../types/Accounting/CenterCost/CenterCostTypes';
import { apiBaseUrl, apiCall } from '../api';

const baseURL = apiBaseUrl;

export const getCenterCostListByTypeFromApi = async (type: string): Promise<CenterCostData[]> => {
  const init = {
    method: 'GET',
    auth: true,
  };

  const { data } = await apiCall<{ data: CenterCostData[] }>(`${baseURL}/center_costs/${type}`, init);
  return data;
};

export const getCenterCostFromApi = async (type: string, id: number): Promise<CenterCostData> => {
  const init = {
    method: 'GET',
    auth: true,
  };

  const { data } = await apiCall<{ data: CenterCostData }>(`${baseURL}/center_costs/${type}/${id}`, init);
  return data;
};

export const createCenterCostFromApi = async (type: string, centerCost: CenterCostData): Promise<CenterCostData> => {
  const init = {
    method: 'POST',
    auth: true,
    body: JSON.stringify(centerCost),
  };
  const { data } = await apiCall<{ data: CenterCostData }>(`${baseURL}/center_costs/${type}`, init);
  return data;
};

export const updateCenterCostFromApi = async (type: string, centerCost: CenterCostData): Promise<CenterCostData> => {
  const init = {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(centerCost),
  };
  const { data } = await apiCall<{ data: CenterCostData }>(`${baseURL}/center_costs/${type}/${centerCost.id}`, init);
  return data;
};

export const deleteCenterCostFromApi = async (type: string, id: number): Promise<void> => {
  const init = {
    method: 'DELETE',
    auth: true,
  };

  await apiCall<{ data: CenterCostData[] }>(`${baseURL}/center_costs/${type}/${id}`, init);
};
